import { default as pLimit, LimitFunction as PLimitFunction } from "p-limit";

let nextId = 0;

export interface Mutex {
  name: string;
  pLimit: PLimitFunction;
  semaphore: number;
}

export function createMutex(name?: string): Mutex {
  try {
    return {
      name: name == null ? `mutex${nextId}` : `mutex${nextId}-${name}`,
      pLimit: pLimit(1),
      semaphore: 0,
    };
  } finally {
    nextId++;
  }
}
